module.exports = __webpack_public_path__ + "static/media/1001012HG.636e303f.jpg";